export default "__VITE_ASSET__B1512_70__"